export type { ImageSwatchProps, ImageSwatchSlots, ImageSwatchState } from './components/ImageSwatch/index';
export {
  ImageSwatch,
  imageSwatchClassNames,
  renderImageSwatch_unstable,
  useImageSwatchStyles_unstable,
  useImageSwatch_unstable,
} from './components/ImageSwatch/index';
